//This configures the styling for the offer accordion which includes the Bold sub widget, bundle discount/multi-buy, Gocertify widget and accordion title
//It is used to hide the multi-buy and bold sub widget when they are empty and also restyles the borders and corners for the accordians
function initOffersAccordion( )
{    
    //console.log( blockArray );

    var noBsub = true;
    var noBundleDiscount = false;
    var noGoCertify = true;
    var noAftersell = true;
    var inQuickView = false;
    filteredBlocks = [];
    blocksToHide =[];

    for ( var i = 0; i < blockArray.length; i ++ )
    {
        var blockId =  blockArray[ i ];
        var block = document.querySelector( ".block-" + blockId );

        if ( block )
        {
            if ( inQuickView === false && block.matches( "quick-view-modal .block-" + blockId ) )
            {
                var inQuickView = true
            }
            if ( blockId.includes( "bold_subscriptions_bsub_widget" ) )
            {
                if ( block.querySelector( ".bsub-widget" ) )
                {
                    filteredBlocks.push( blockId );
                    noBsub = false;
                }
                else
                {
                    blocksToHide.push( blockId );
                }
            }
            else if ( blockId.includes( "gocertify_iframe" ) )
            {
                filteredBlocks.push( blockId );
                noGoCertify = false;
            }
            else if ( blockId.includes( "aftersell_by_rokt_pdp_upsells" ) )
            {
                if ( block.querySelector( "#aftersell-pdp-upsell" ).shadowRoot )
                {
                    filteredBlocks.push( blockId );
                    noAftersell = false;
                }
                else
                {
                    blocksToHide.push( blockId );
                }
            }
            else if ( !block.querySelector( ".js_block_not_empty" ) )
            {
                if ( blockId.includes( "bundle_discount" ) )
                {
                    noBundleDiscount = true;
                }
                blocksToHide.push( blockId );
            }
            else
            {
                filteredBlocks.push( blockId );
            }
        }
    };

    //console.log( emptyBsub, noBundleDiscount, noGoCertify, inQuickView );

    if ( noBsub && noBundleDiscount && noGoCertify && inQuickView === false )
    {
        filteredBlocks.forEach( blockId => 
        {
            var block = document.querySelector( ".block-" + blockId );
            block.style.display = "none";
        });
    }
    else if ( noBundleDiscount && noGoCertify && inQuickView === true )
    {
        filteredBlocks.forEach( blockId => 
        {
            var block = document.querySelector( ".block-" + blockId );
            block.style.display = "none";
        });
    }
    else
    {
        filteredBlocks.forEach( ( blockId, i ) => 
        {
            var block = document.querySelector( ".block-" + blockId );
            block.style.visibility = "visible";

            if ( i == 0 )
            {
                var firstBlock = document.querySelector( ".block-" + blockId );
                firstBlock.style.borderBottom = "none";
                firstBlock.style.borderTop = "1px solid #cccccc";
                firstBlock.style.borderRadius = "0.375rem 0.375rem 0px 0px"
            }
            else if ( i == filteredBlocks.length - 1 )
            {
                var lastBlock = document.querySelector( ".block-" + blockId );
                lastBlock.style.borderBottom = "1px solid #cccccc";
                lastBlock.style.borderTop = "none";
                lastBlock.style.borderRadius = "0px 0px 0.375rem 0.375rem";
            }
            else
            {
                var middleBlock = document.querySelector( ".block-" + blockId );
                middleBlock.style.borderBottom = "none";
                middleBlock.style.borderTop = "none";
                middleBlock.style.borderRadius = "0px"
            }
        });
        blocksToHide.forEach( blockId => 
        {
            var block = document.querySelector( ".block-" + blockId );
            block.style.display = "none";
        });
    }
}

initOffersAccordion( );